import * as time from "../../utils/time";

export function getEntriesFilteredByDates(entries, firstDate, secondDate, from_or_until) {
  // filter entries from a date onwards, or up until a date

  if (secondDate == undefined) {
    return entries.filter((entry) => {
      let entry_date = secondDate || entry[0];
      if (from_or_until == "from") {
        return time.compareTwoDatesExcludingTime(entry_date, firstDate);
      } else {
        return time.compareTwoDatesExcludingTime(firstDate, entry_date);
      }
    });
  } else {
    return entries.filter((entry) => {
      let entry_date = entry[0];
      return (
        time.compareTwoDatesExcludingTime(entry_date, firstDate) &&
        time.compareTwoDatesExcludingTime(secondDate, entry_date)
      );
    });
  }
}
